<script setup>
import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useProfileStore } from '@/stores/profile'
import { useUsersStore } from '@/stores/users'
import { useConfigStore } from '@/stores/config'
import { useRoute } from 'vue-router'
import { usePageNavi } from '@/composables/usePageNavi.js'
import userName from '@/helpers/userName'
import setPageTitle from '@/helpers/setPageTitle'

const props = defineProps({
    uuid: {
        type: String
    }
})

const { isOpenPageNavi, togglePageNavi } = usePageNavi()

const translaterStore   = useTranslaterStore()
const profileStore      = useProfileStore()
const usersStore        = useUsersStore()
const configStore       = useConfigStore()

const route = useRoute()

const getTranslate  = computed(() => translaterStore.getTranslate)
const profile       = computed(() => profileStore.profile)
const user          = computed(() => usersStore.user)

const userUuid = props.uuid || localStorage.getItem('UTA_UUID')
const appName = configStore.appName

if(profile.value.uuid !== userUuid) {
    setPageTitle(route.meta.breadcrumbs)
} else {
    document.title = getTranslate.value.MENU_PROFILE + ' - ' + appName
}
</script>

<template>
    <div class="uta-aside-navi">
        <nav class="navbar navbar-expand-lg uta-aside-navi__navbar">
            <div class="navbar-brand uta-aside-navi__navbar-header">{{ userName( route.path == '/profile' ? profile : user ) || getTranslate.USERS_NEW_USER }} </div>
            <button 
                class="navbar-toggler uta-aside-navi__button"
                type="button"
                @click="togglePageNavi"
            >
                <div class="uta-aside-navi__icon" :class="{ 'uta-aside-navi__icon--close': isOpenPageNavi}">
                    <div class="uta-aside-navi__icon-item"></div>
                    <div class="uta-aside-navi__icon-item"></div>
                    <div class="uta-aside-navi__icon-item"></div>
                </div>

            </button>
            <div
                class="uta-aside-navi__navbar-sidebar"
                :class="{ 'uta-aside-navi__navbar-sidebar--opened': isOpenPageNavi }"
            >
                <ul class="navbar-nav uta-aside-navi__navbar-nav">
                    <li class="nav-item">
                        <router-link :to="'/users/' + userUuid" class="uta-aside-navi__link">{{ getTranslate.MENU_USER_INFO }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="'/users/' + userUuid + '/cars'" class="uta-aside-navi__link" v-if="profile.attr?.array.includes('SUPER_ADMIN')">{{ getTranslate.MENU_USER_CARS }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="'/users/' + userUuid + '/logs'" class="uta-aside-navi__link" v-if="profile.attr?.array.includes('SUPER_ADMIN')">{{ getTranslate.MENU_USER_LOGS }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="'/users/' + userUuid + '/password'" class="uta-aside-navi__link">{{ getTranslate.MENU_USER_PASS }}</router-link>
                    </li>
                </ul>
            </div>
            <transition name="fade">
                <div v-if="isOpenPageNavi" class="uta-aside-navi__navbar-backdrop" @click="togglePageNavi"></div>
            </transition>
        </nav>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/aside-navi.scss';
</style>